module.exports = __webpack_public_path__ + "static/media/River2.2636c9e4.jpeg";